import { useState } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { PortfolioSizeProvider } from "@/components/wizard-steps/portfolio/PortfolioSizeContext";
import { InvestmentStrategyProvider, StrategyType } from "@/components/wizard-steps/investment-strategy/InvestmentStrategyContext";
import StepIndicator from "@/components/wizard/StepIndicator";
import { WizardStep } from "@/components/wizard/types";
import { createWizardSteps } from "@/components/wizard/wizardSteps";

const Wizard = () => {
  const [currentStep, setCurrentStep] = useState<WizardStep>(1);
  const [selectedStrategy, setSelectedStrategy] = useState<StrategyType>();

  const handleNext = () => {
    if (currentStep < 7) {
      setCurrentStep((prev) => (prev + 1) as WizardStep);
    }
  };

  const handleStepClick = (step: WizardStep) => {
    if (step <= currentStep) {
      setCurrentStep(step);
    }
  };

  const handleStrategySelect = (strategy: StrategyType) => {
    setSelectedStrategy(strategy);
  };

  const steps = createWizardSteps(handleNext, handleStrategySelect, selectedStrategy);

  return (
    <div className="min-h-screen bg-gray-50 py-6">
      <div className="max-w-2xl mx-auto px-4">
        <PortfolioSizeProvider>
          <InvestmentStrategyProvider>
            <Accordion
              type="single"
              defaultValue={`step-${currentStep}`}
              value={`step-${currentStep}`}
              className="w-full bg-white rounded-lg shadow-lg"
            >
              {steps.map(({ number, title, component }) => (
                <AccordionItem
                  key={number}
                  value={`step-${number}`}
                  className={`${
                    number < currentStep
                      ? "bg-navy/5"
                      : number === currentStep
                      ? "bg-white"
                      : "bg-gray-50"
                  }`}
                >
                  <AccordionTrigger
                    className={`px-4 hover:no-underline ${
                      number === currentStep ? "text-navy font-semibold" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleStepClick(number as WizardStep);
                    }}
                  >
                    <div className="flex items-center gap-4">
                      <StepIndicator 
                        step={number} 
                        currentStep={currentStep} 
                        onClick={() => handleStepClick(number as WizardStep)}
                        disabled={number > currentStep}
                      />
                      <span>{title}</span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="px-4 pb-4">
                    {component}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </InvestmentStrategyProvider>
        </PortfolioSizeProvider>
      </div>
    </div>
  );
};

export default Wizard;